import React from "react";
import {useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import {useSubscription} from "../../subscription/useSubscription";
import PageSection from "../../elements/PageSection";
import {CompanyWithinPortfolioHeader} from "./CompanyWithinPortfolioHeader";
import GroupingsLayout from "../grouping/GroupingsLayout";
import KpiChooser from "../kpi/KpiChooser";
import OurProgrammeContext, {subscriptionUrl} from "../navigation/OurProgrammeContext";
import {CentredLoader} from "../../elements/Loader";

const CompanyWithinPortfolioPage = ({}) => {
    const params = useParams();
    const history = useHistory();
    useSubscription("COMPANY_WITHIN_PORTFOLIO", subscriptionUrl(params), 60);
    const company = useSelector(state => state.company);

    if (!company.settings) {
        return <div style={{padding: 20}}><CentredLoader/></div>;
    }

    const {overallGrouping, settings, availablePeriods, groupings} = company;
    const {portfolioName, primaryGroup, currency, rewardPeriod} = settings;

    const {portfolioId, companyId} = params;
    const authorRanking = groupings ? groupings.author.results : [];

    const companyWithinPortfolioName = overallGrouping ? overallGrouping.groupName : "";
    const ourProgrammeContext = new OurProgrammeContext(params, portfolioName, companyWithinPortfolioName, rewardPeriod);


    const kpiChooser = new KpiChooser(settings);

    return (
        <div>
            <CompanyWithinPortfolioHeader company={company}
                                          portfolioId={portfolioId}
                                          selectedKpi={kpiChooser.selectedKpi({isAdditionalGrouping: false})}
                                          periods={availablePeriods}
                                          ourProgrammeContext={ourProgrammeContext}
            />
            <PageSection>
                <GroupingsLayout showAdditionalGroupings={true}
                                 groupings={groupings}
                                 currency={currency}
                                 kpiChooser={kpiChooser}
                                 portfolioId={portfolioId}
                                 portfolioName={portfolioName}
                                 authorRanking={authorRanking}
                                 primaryGroup={primaryGroup}
                                 companyId={companyId}
                                 getExploreUrlFor={ourProgrammeContext.exploreGroupingHref.bind(ourProgrammeContext)}
                                 getExportUrlFor={ourProgrammeContext.exportGroupingHref.bind(ourProgrammeContext)}
                                 pageName={"CompanyWithinPortfolioPage"}
                                 programmeContext={ourProgrammeContext.context()}
                />

            </PageSection>
        </div>
    );
};

export default CompanyWithinPortfolioPage;
